<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <path d="M8 12l4 4 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 3v13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>

<script>
// Иконка скачивания — один маркап на обе кнопки карточки.
// Класс навешивает потребитель: компонент общий и про оформление кнопок не знает.
export default {
    name: 'DownloadIcon',
};
</script>
